import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';
import { ProductOperation } from '../../../models/product-operation.model';

@Component({
  standalone: false,
  selector: 'app-operation-autocomplete',
  templateUrl: './operation-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})

export class OperationAutocompleteComponent {
  @Input() searchTerm: string;
  @Input() placeholder: string;
  @Input() sector: string;
  operations: Array<ProductOperation> = [];
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sharedService: SharedService,
              private message: MessageService) {}

  getOperations(): void {
    this.sharedService.getAllOperations(this.searchTerm, this.sector).subscribe(
      res => {
        this.operations = res.results;
        this.isListVisible = this.operations.length > 0 && this.searchTerm.length > 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelect(operation: ProductOperation): void {
    this.selected.emit(operation);
    this.isListVisible = false;
  }
}